import styled from 'styled-components';
import { mixins, styles } from '4all-ui/styles';
import RightIconSvg from '../../../../images/down.svg';

export const OrderItemContainer = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  background-color: ${styles.colors.WHITE};
  color: grey;
  cursor: pointer;

  :first-of-type {
    border-top: none !important;
  }

  border-top: 1px solid #a0a0a0;
  
  h3 {
    ${mixins.fontStyle(
      styles.colors.GRAY_DARKER,
      styles.fontSizes.SIZE_3,
      styles.fontWeights.SEMIBOLD
    )}
  }

  h4 {
    font-size: 17px;
    font-weight: 600;
    line-height: 1.01;
    letter-spacing: -0.2px;
    margin-top: -3px;
  }

  @keyframes HeightIncrease {
    0%   { height: 0%; }
    100% { height: 100%;}
  }

  ${({ selected }) =>
    selected &&
    `
    box-shadow: 0px 0px 20px -10px rgba(0, 0, 0, 0.75);
    border-top: 1px solid transparent !important;
    position: relative;

    ::before{
      content: '';
      background: ${styles.colors.MAIN_COLOR};
      height: 100%;
      position: absolute;
      width: 5px;
      left: 0px;
      animation: HeightIncrease 0.2s normal;
    }

    ::after{
      content: '';
      background: ${styles.colors.MAIN_COLOR};
      height: 100%;
      position: absolute;
      width: 5px;
      right: 0px;
      animation: HeightIncrease 0.2s normal;
    }

    + div {
      border-top: 1px solid transparent !important;
    }
  `}

  
`;

export const ContentItem = styled.div`
  padding: 10px 15px 10px 15px;
  width: 100%;
  ${({ selected }) => selected && `padding-left: 12px;`}
`;

export const ContentOrder = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  margin-bottom: 20px;
`;

export const Describe = styled.span`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
`;

export const ContentClient = styled.div`
  margin-bottom: 6px;
  ${mixins.flexPosition({})}
  padding-bottom: 5px;
  border-bottom: 1px solid ${styles.colors.GRAY_LIGHT_2};
`;

export const ClientName = styled.div`
  max-width: 200px;
  word-break: break-word;
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_5, styles.fontWeights.NORMAL)}
`;

export const RemovalType = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.NORMAL
  )}
  margin-top: 10px;
  margin-bottom: 15px;
`;

export const RightInfos = styled.div``;

export const ContentArea = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  height: 25px;
  line-height: 25px;

  .inline-block {
    display: inline-block;
  }

  .text-order-type {
    font-weight: bold;
  }

  .icon-arrow {
    width: 10px;
    height: 8px;
    display: inline-block;
    margin: 0 5px;
    background: url('../../../../../../static/img/arrow.svg') no-repeat;
  }
`;

export const InlineBlock = styled.div`
  display: inline-block;
`;

export const DescribeValue = styled.span`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_5,
    styles.fontWeights.SEMIBOLD
  )}
`;

export const RightIcon = styled.div`
  background-image: url(${RightIconSvg});
  background-repeat: no-repeat;
  width: 17px;
  height: 17px;
  transform: rotate(-90deg);
  margin: 10px 10px 0px 12px;
`;

export const DescribeSale = styled.span`
  ${mixins.flexPosition({ align: 'center' })}
  font-size: ${styles.fontSizes.SIZE_7};
  font-weight: ${styles.fontWeights.SEMIBOLD};
  height: 20px;

  svg {
    margin-left: 5px;
    margin-right: 10px;
  }
  ${props => props.customStyles}
`;

export const PaymentLabel = styled.span`
  margin-left: 5px;
  color: ${props => props.color || styles.colors.GRAY_MEDIUM_3};
`;



// WEBPACK FOOTER //
// ./src/components/OrderList/SearchResultsBox/OrderItem/style.js